export default __webpack_public_path__ + "static/media/potter.ed100122.png";